define('collections/action_histories',['require','collections/base','models/action_history'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/action_history");

    return BaseCollection.extend({
        model: Model,
        url: 'action-histories.json'
    });
});

